import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExameNaturezaDto } from '../dtos/exames/exame-natureza-dto';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class ExameNaturezaService {

  constructor(private http: HttpClient, private url: UrlService) { }

  listarNaturezas(apenasMapeadosEsocial: boolean, tudo: boolean): Observable<ExameNaturezaDto[]> {
    let p = new HttpParams();
    
    let filtro = p
    .append('apenasMapeadosEsocial', apenasMapeadosEsocial)
    .append('tudo', tudo);

    return this.http.get<ExameNaturezaDto[]>(this.url.url('exames/naturezas'), { params: filtro });
  }

  consultarNatureza(id: number): Observable<ExameNaturezaDto> {
    return this.http.get<ExameNaturezaDto>(this.url.url(`exames/naturezas/${id}`));
  }
}
